import { gql } from '@apollo/client'

export const GET_IMAGE = gql`
  query GetImage($key: String!) {
    getImage(key: $key)
  }
`
